@if (workstationCode(); as code) {
    <a routerLink="/workstation" class="indicator" [title]="code">
        <app-icon name="computer-desktop" />
        <span class="code">{{ code }}</span>
        @if (hasPrinterWarning()) {
            <app-icon name="triangle-exclamation" class="warning" />
        }
        <span class="change">{{ 'header.switch-workstation' | translate }}</span>
    </a>
}
